import { TRoadblockConfiguration } from "../roadblockTypesAndCodecs";
import { fact, formatEvidenceDate } from "../evidence/evidenceHelpers";
import { TRoadblockEvidenceLink } from "../../codecs/form/RoadblockForm";

const quotesLink: TRoadblockEvidenceLink = { block: "case_quotes", section: null };

export const Quote: TRoadblockConfiguration = {
    type: "quote",
    display_name: "Quote",
    only_create_if_resolved: [],
    requires_authoriser_signoff: false,
    blocks_exchange: true,
    create: {
        create_condition_description: "Cases that have been upgraded to a quote (not property-report-only) and have not yet completed",
        predicate: (c) => !c.case.is_property_report && c.case.has_completed === null
    },
    checklist: [
        {
            type: "quote_created",
            is_resolved_by_short_description: "Quote created",
            create: {
                create_condition_description: "All cases",
                predicate: () => true
            },
            resolve: {
                is_resolved_by_long_description: `Adding a quote to the case (with the same transaction type as the case).`,
                predicate: (c) => c.quotes.length > 0,
                evidence: (c) => [
                    fact("Quote", c.quotes.length > 0 ? "Created" : "Not created", c.quotes.length > 0, quotesLink),
                ],
            }
        },
        {
            type: "quote_sent",
            is_resolved_by_short_description: "Quote sent",
            create: {
                create_condition_description: "All cases",
                predicate: () => true
            },
            resolve: {
                is_resolved_by_long_description: `Sending the quote to the client, and marking it as sent in the CRM.`,
                predicate: (c) => c.case.quote_sent_to_client ? true : false,
                evidence: (c) => [
                    fact(
                        "Quote sent",
                        c.case.quote_sent_to_client ? `Sent ${formatEvidenceDate(c.case.quote_sent_to_client)}` : "Not sent",
                        c.case.quote_sent_to_client !== null,
                        quotesLink,
                    ),
                ],
            }
        }
    ]
};